export default function ModalTitle({ className = "", text, id }) {
    return (
        <h5
            id={id}
            className={`modal-title text-center 
        --tw-font-['Suisse_Intl'] tw-font-medium tw-text-[24px] tw-leading-[140%] tw-text-[#2C323A]
        tw-mr-auto sm:tw-m-auto ${className}`}
        >
            {text}
        </h5>
    );
}